import React, { useState, useEffect } from 'react';
import './Spinner.scss';
import { connect } from 'react-redux'

const Spinner = (props) => {

    const [state, setState] = useState(false)

    useEffect(() => {
        setState(props.spinner)
    }, [props.spinner])

    return (
        <React.Fragment>
            {
                state &&
                <div className="spinner-content">
                    <img src="/static/img/spinner-fansa.giff" alt="" />
                </div>
            }
        </React.Fragment>
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(Spinner)
